import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Services";
import getToken from "app/api/getToken";

import { IService } from "app/api/types/Services";

export const EDIT_SERVICE_REQUEST = "EDIT_SERVICE_REQUEST";
export const EDIT_SERVICE_SUCCESS = "EDIT_SERVICE_SUCCESS";
export const EDIT_SERVICE_FAIL = "EDIT_SERVICE_FAIL";

export const editService = (data: IService) => (dispatch: any): any => {
  dispatch({ type: EDIT_SERVICE_REQUEST });

  const token = getToken();

  return api
    .editService(token, data)
    .then((response: AxiosResponse) => {
      const master: IService = get(response, "data", {});
      dispatch({ type: EDIT_SERVICE_SUCCESS, payload: master });

      return master;
    })
    .catch(err => {
      dispatch({
        type: EDIT_SERVICE_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
